// import logo from './logo.svg';
import './App.css';
import CommentStructure from './CommentStructure.js';

function App() {
  return (
    <div>
      <CommentStructure/>
    </div>
  );
}

export default App;
